<template>
  <div class="busRoute">
    <div class="busRoute__header1">
      <button class="btn-large primary" @click="addNew">Add New Location</button>
    </div>
    <div class="busRoute__header2">
      <div class="busRoute__header2__search">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search" />
      </div>
      <div class="busRoute__header2__sort">
        <p>Sort by :</p>
        <div>
          <a-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="busRoute__listing">
      <div class="tableWrapper">
        <table>
          <thead>
            <tr>
              <td class="col1">ITEMS</td>
              <td class="col2">ADDED PLACEMENT</td>
              <td class="col2">PIC</td>
              <td class="col2">BRAND</td>
              <td class="col3"></td>
            </tr>
          </thead>

          <tbody v-if="!isLoading">
            <tr v-for="(location, index) in locations" :key="index" class="content">
              <td class="col1">
                <div class="routeGroup">
                  <div class="subhead route name">{{location.name}}</div>
                  <div class="small-font detail">{{location.city.name}}</div>
                </div>
              </td>
              <td v-if="location.billboardPlacements.length === 0" class="col2">
                <span>-</span>
              </td>
              <td
                v-else-if="location.billboardPlacements.length > 0 && location.billboardPlacements.length <= 2"
                class="col2"
              >
                <div
                  v-for="(placement, index) in location.billboardPlacements"
                  :key="index"
                  class="subhead elipsis"
                >{{placement.name}}</div>
              </td>
              <td v-else-if="location.billboardPlacements.length > 2" class="col2">
                <div :class="[show[index] ? '': 'hidden']">
                  <div
                    v-for="(placement, index) in location.billboardPlacements"
                    :key="index"
                    class="subhead elipsis"
                  >{{placement.name}}</div>
                </div>
                <div v-if="!show[index]" class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show More</span>
                  <i class="icon-chevrondown"></i>
                </div>
                <div v-else class="showButton">
                  <span class="small-font toggleShow" @click="showMore(index)">Show Less</span>
                  <i class="icon-chevronup"></i>
                </div>
              </td>
              <td class="col2">
                <template v-if="location.pic.length > 0">
                  <span
                    class="subhead owner"
                    v-for="(user, index) in location.pic"
                    :key="index"
                  >{{user.email}}</span>
                </template>
                <template v-else>-</template>
              </td>
              <td class="col2">
                <span class="subhead owner">{{location.brand.title}}</span>
              </td>
              <td class="col3">
                <a-menu-expansion
                  :lists="location.billboardPlacements == 0 ? menuActions: menuActionsNot"
                  @selected="selected($event, location)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="emptyState">
        <a-empty-selection v-if="locations.length == 0 && !isLoading" :title="title" />
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <a-loading />
      </div>
      <div class="pagination" v-if="!isLoading && locations.length > 0">
        <div class="total">{{getDataRange}} of {{count}} Billboards</div>
        <a-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage" />
      </div>
    </div>
    <a-modal hideClose="true" v-if="isShowModal" title="Delete Route" type="small">
      <div slot="content" class="busRoute__modal">
        <div class="busRoute__modal__top">
          <span>Sure want to delete this route?</span>
        </div>
        <div class="busRoute__modal__bottom">
          <button class="btn-regular primary" @click="deleteLocation">
            Yes
            <a-loading-2 class="btn-loading" v-if="isLoadingMutation" />
          </button>
          <button class="btn-regular primary" @click="cancelDelete">Cancel</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  ALoadingPrimary,
  ALoadingSecondary,
  ALoadingSecondaryWhite,
  AEmptySelection,
  AModal,
  ASelectDropdown,
  APagination,
  AMenuExpansion
} from "ui-kit-v1";

import { restEdge } from "@/api/edgeUrls";
import api from "@/api";
import * as validationLib from "@/lib/validation/";

const { helpers } = validationLib;

export default {
  name: "adx-channel-billboard-location",
  components: {
    "a-modal": AModal,
    "a-empty-selection": AEmptySelection,
    "a-loading": ALoadingPrimary,
    "a-loading-2": ALoadingSecondaryWhite,
    "a-dropdown-sort": ASelectDropdown,
    "a-pagination": APagination,
    "a-menu-expansion": AMenuExpansion
  },
  props: {},
  data() {
    return {
      locations: [],
      searchBoxValue: "",
      selectedLocationId: 0,
      selectedSortValue: "last_added",
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added"
        },
        {
          label: "First Added",
          value: "first_added"
        },
        {
          label: "Name",
          value: "name"
        }
      ],
      isLoading: false,
      show: [],
      selectedPage: 1,
      menuActions: [
        {
          id: 0,
          name: " Edit Billboard",
          value: "editbillboard"
        },
        {
          id: 1,
          name: " Duplicate Billboard",
          value: "duplicatebillboardlocation"
        },
        {
          id: 2,
          name: "Delete Billboard",
          value: "deletebillboardlocation"
        }
      ],
      menuActionsNot: [
        {
          id: 0,
          name: " Edit Billboard",
          value: "editbillboard"
        },
        {
          id: 1,
          name: " Duplicate Billboard",
          value: "duplicatebillboardlocation"
        },
        {
          id: 2,
          name: "Delete Billboard",
          value: "deletebillboardlocation",
          disabled: "You must remove all placement first.",
          position: "top"
        }
      ],
      count: 0,
      maxPage: 1,
      isShowModal: false,
      isLoadingMutation: false
    };
  },
  computed: {
    getDataRange: function() {
      let endPage = this.selectedPage * 15;
      return this.count > 15
        ? endPage < this.count
          ? endPage
          : endPage - 15 + (this.count % 15)
        : this.count;
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(function() {
        this.selectedPage = 1;
        this.count = 0;
        this.loadData();
      });
    }, 500),
    selectedSortValue: helpers.debounce(function() {
      this.$nextTick(function() {
        this.selectedPage = 1;
        this.count = 0;
        this.loadData();
      });
    }, 500)
  },
  beforeCreate() {},
  created() {
    this.loadData();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    addNew() {
      this.$router.push({ name: "addnewbillboardlocation" });
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      // this.getRoutes()
    },
    async loadData() {
      this.isLoading = true;
      const params = {
        search: this.searchBoxValue,
        sort: this.selectedSortValue,
        page: this.selectedPage
      };
      const response = await api.get(restEdge.getBillboardLocation, {
        needToken: true,
        useRestEdge: true,
        params: params
      });

      if (response.status == 200) {
        this.locations = response.data.results;
        this.count = response.data.count
        this.isLoading = false;
      }
    },
    selected(index, item) {
      if (index.value === "editbillboard") {
        this.$router.push({
          name: "editbillboardlocation",
          params: { id: item.id }
        });
      } else if (index.value === "duplicatebillboardlocation") {
        this.duplicateLocation(item.id);
      } else if (index.value === "deletebillboardlocation") {
        this.confirmDelete(item.id);
      }
    },
    confirmDelete(id){
      this.selectedLocationId = id;
      this.toggleModal()
    },
    cancelDelete() {
      this.toggleModal()
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    async deleteLocation() {
      this.isLoadingMutation = true;
      const response = await api.destroy(restEdge.deleteBillboardLocation(this.selectedLocationId), { needToken: true, useRestEdge: true,});
      if(response.status == 200) {
        this.toggleModal();
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully deleted!', 'success')
      } else {
        this.toggleModal();
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to delete!', 'danger')
      }
    },
    async duplicateLocation(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.duplicateBillboardLocation(id), {}, { needToken: true, useRestEdge: true,});

      if (response.status == 200) {
        this.loadData();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully duplicated!', 'success')
      } else {
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to duplicate!', 'danger')
      }

    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>